import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { BackButton } from "@qgiv/core-donor";
import { hasActiveProductsToBeDisplayed } from "@qgiv/p2p-registration";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectBaseUrl } from "../../../redux/slices/p2pSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllProducts } from "../../../redux/slices/productsSlice";

const ConnectedPaymentBackButton = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const isCms = useSelector(selectIsCms);
    const baseUrl = useSelector(selectBaseUrl);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );
    const {
        options: { backLinkLabel = "Back" },
    } = control;
    const products = useSelector(selectAllProducts);
    const hasProductsInRegistration = hasActiveProductsToBeDisplayed(products);

    const backUrl = `${baseUrl}${
        hasProductsInRegistration ? "/form/store" : "/form/registration"
    }`;

    const backButtonProps = {
        backLinkLabel,
        backLinkUrl: backUrl,
        isCms,
        withRouter: true,
    };

    return <BackButton {...backButtonProps} />;
};

ConnectedPaymentBackButton.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedPaymentBackButton;
